import { call, put } from 'redux-saga/effects';

import { ModalType } from 'const';
import { showModal } from 'containers/ModalManager/actions';
import { getReusableLayoutTags } from 'services/api';
import { handleSagaError } from 'services/handleError';
import { Action } from '../models';

export function* loadLayoutDetailsMetadata(action: Action.LoadLayoutDetailsMetadata): Generator {
  try {
    const { document } = action.payload;
    const response = yield call(getReusableLayoutTags, document.documentId);

    yield put(
      showModal(ModalType.LAYOUT_DETAILS, { document, metadata: response.data }),
    );
  } catch (error) {
    yield call(handleSagaError, error, 'ModalWindows.loadLayoutDetailsMetadata', 'Load Layout Details Metadata');
  }
}
